/* PDP — BobaFashion sticky ATC + price-sync logic.
 * Vanilla JS, no deps. Uses IntersectionObserver to show/hide the sticky bar
 * based on visibility of the main ATC button, and syncs the displayed price
 * with the theme's existing variant-change events. */
(function () {
  if (typeof window === 'undefined') return;

  function init() {
    var sticky = document.querySelector('[data-pdp-sticky-atc]');
    if (!sticky) return;

    var formId = sticky.getAttribute('data-form-id');
    var mainForm = formId ? document.getElementById(formId) : null;
    if (!mainForm) {
      // Fallback to first product form on page.
      mainForm = document.querySelector('form[action*="/cart/add"]');
    }

    // Locate the main ATC button to observe its visibility.
    var mainBtn = mainForm ? mainForm.querySelector('[name="add"], button[type="submit"]') : null;

    if (mainBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.classList.remove('is-visible');
          } else {
            sticky.classList.add('is-visible');
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
      io.observe(mainBtn);
    } else {
      // No main button — keep hidden to avoid duplicate ATC.
      sticky.hidden = true;
    }

    // Submit handler — defer to main form so AJAX cart keeps working.
    var stickyBtn = sticky.querySelector('[data-pdp-sticky-submit]');
    if (stickyBtn && mainForm) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (stickyBtn.disabled) return;
        if (typeof mainForm.requestSubmit === 'function') {
          mainForm.requestSubmit();
        } else {
          // Fallback for Safari < 16.
          var submit = mainForm.querySelector('[type="submit"]');
          if (submit) submit.click();
          else mainForm.submit();
        }
      });
    }

    // Price sync — listen for theme's existing variant-change events.
    // The Flex theme dispatches 'variantChange' on the product section.
    var priceEl = sticky.querySelector('[data-pdp-sticky-price]');
    var section = sticky.closest('[data-section-type="product"]');
    if (priceEl && section) {
      section.addEventListener('variantChange', function (e) {
        var v = e && e.detail && e.detail.variant;
        if (!v) return;
        // Use the theme's data-product-price as source of truth if present.
        var primaryPrice = section.querySelector('[data-product-price]');
        if (primaryPrice) priceEl.textContent = primaryPrice.textContent.trim();
        if (stickyBtn) {
          stickyBtn.disabled = !v.available;
        }
      });
    }
  }

  /* ---- Color swatches: map variant.featured_image to each color label ----
   * The Flex theme renders color swatches as <label class="color-swatch"> with
   * inline background-color (and sometimes background-image). We enhance this
   * by reading the variant JSON and overriding background-image with each
   * variant's featured_image when present. */
  function enhanceSwatches(section) {
    if (!section) return;
    var jsonEl = section.querySelector('[data-variant-json]');
    if (!jsonEl) return;
    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    // Find color/kleur option index from the rendered fieldsets.
    var fieldsets = section.querySelectorAll('.variant-input-wrap');
    fieldsets.forEach(function (fs) {
      var name = (fs.getAttribute('name') || '').toLowerCase();
      var isColor = name.indexOf('color') !== -1 || name.indexOf('colour') !== -1 || name.indexOf('kleur') !== -1;
      if (!isColor) return;

      var optionKey = (function () {
        // Match against variant.option1/2/3 by finding which option index this is.
        var idx = fs.getAttribute('data-index'); // 'option1' | 'option2' | 'option3'
        return idx || 'option1';
      })();

      var inputs = fs.querySelectorAll('input[type="radio"]');
      inputs.forEach(function (input) {
        var value = input.value;
        var match = variants.find(function (v) { return v[optionKey] === value && v.featured_image; });
        if (!match) return;
        var url = (match.featured_image && (match.featured_image.src || match.featured_image)) || '';
        if (!url) return;
        // Use a smaller image for the swatch.
        var sized = url.replace(/(\.(jpe?g|png|webp|gif))(\?.*)?$/i, '_120x$1$3');
        var label = input.nextElementSibling;
        if (label && label.classList.contains('color-swatch')) {
          label.style.backgroundImage = 'url(' + sized + ')';
        }
      });
    });
  }

  /* ---- Variant color strip click handler ----
   * On click, try to trigger the matching variant picker radio (instant switch
   * via theme's existing variant-change JS). If no matching radio exists (e.g.
   * variant_picker block disabled), fall back to navigating to the variant URL. */
  function initVariantStrip() {
    var strips = document.querySelectorAll('[data-pdp-variant-strip]');
    strips.forEach(function (strip) {
      var links = strip.querySelectorAll('.pdp-variant-strip__link');
      links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          var color = link.getAttribute('data-color-value');
          if (!color) return;
          // Try to find matching radio in variant picker (case-insensitive name match).
          var radios = document.querySelectorAll('input[type="radio"][data-variant-input]');
          var matched = null;
          radios.forEach(function (r) {
            if (matched) return;
            var v = (r.getAttribute('value') || '').trim();
            if (v.toLowerCase() === color.toLowerCase()) matched = r;
          });
          if (matched) {
            e.preventDefault();
            matched.checked = true;
            matched.dispatchEvent(new Event('change', { bubbles: true }));
            // Update active class on strip.
            strip.querySelectorAll('.pdp-variant-strip__item').forEach(function (i) {
              i.classList.remove('is-active');
            });
            link.parentElement.classList.add('is-active');
          }
          // If no matched radio, let the <a> default to navigate to ?variant=ID.
        });
      });
    });
  }

  function initAll() {
    init();
    document.querySelectorAll('[data-section-type="product"]').forEach(enhanceSwatches);
    initVariantStrip();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
